/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Footer/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BackToPatientOverlayAction from './BackToPatientOverlayAction/index'
import CloseAction from './CloseAction/index'
import React from 'react'
import SubmitAction from './SubmitAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Footer({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/Footer"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Footer.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2unNA3': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<BackToPatientOverlayAction
  viewPath={`${viewPath}/BackToPatientOverlayAction`}
/>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
</div>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
{children}
</React.Fragment>)
}